import React from "react";
import styled from "styled-components";
import Tooltip from "./Tooltip";
import { ProductRating } from "../imports";
import { device } from "../../../utils/breakPoints";
import ShopifyPayIcon from "./ShopifyPayIcon";
import QuantityPurchase from "../../QuantityPurchase";

const TOOLTIP_TITLE = "Shop Pay";
const TOOLTIP_MESSSAGE = `Shop Pay allows you to streamline your shopping by saving your email,
card, shipping, and billing information to make checkout a breeze.
Shop Pay also allows you to pay for your purchases in 4 installments
to make life a little easier on your pocketbook.`;

export default function ProductDetailHead({ title, price, selectedProduct }) {
  const hasPrice = price !== "";
  return (
    <Container>
      <Title>
        {title}
      </Title>
      {hasPrice && <TotalPrice>${price}</TotalPrice>}
      <QuantityPurchase selectedProduct={selectedProduct} />
      <MoreInfoContainer>
        <ProductRating />
        <ShopifyPayIcon />
        <Tooltip
          tooltipMessage={TOOLTIP_MESSSAGE}
          tooltipHeadLine={TOOLTIP_TITLE}
        />
      </MoreInfoContainer>
    </Container>
  );
}

const Container = styled.div``;

const MoreInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;
const Title = styled.p`
  text-align: left;
  font-size: 32px;
  font-weight: 500;
  color: black;
  line-height: 1.2;
  margin: 0;
  padding-bottom: 8px;
  font-family: "sofia-pro";
  @media ${device.tablet} {
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
  }
`;
const SubTitle = styled.span`
  display: block;
`;
const TotalPrice = styled.p`
  color: black;
  font-weight: 400;
  font-size: 18px;
  margin: 0;
  text-align: left;
  
`;
